export default __webpack_public_path__ + "static/media/sogaz.24fef369.svg";